import styles from './Problem.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  ProblemEach: {
    titleProblem: string
    problem1: string
    problem2?: string
    problem3?: string
    problem4?: string
    problem5?: string
    titleCanDo: string
    CanDo1: string
    CanDo2?: string
    CanDo3?: string
    CanDo4?: string
    CanDo5?: string
  }
}

const Problem: React.FC<Props> = ({ ProblemEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.problemCanDo} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <section className={styles.problem}>
        <h2 className={styles.problem__title}>{ProblemEach.titleProblem}</h2>
        <ul className={styles.problem__list}>
          {[
            ProblemEach.problem1,
            ProblemEach.problem2,
            ProblemEach.problem3,
            ProblemEach.problem4,
            ProblemEach.problem5,
          ]
            .filter(Boolean)
            .map((item, idx) => (
              <li className={styles.problem__list__item} key={idx}>
                {item}
              </li>
            ))}
        </ul>
      </section>
      <section className={styles.canDo}>
        <h2 className={styles.canDo__title}>{ProblemEach.titleCanDo}</h2>
        <ul className={styles.canDo__list}>
          {[ProblemEach.CanDo1, ProblemEach.CanDo2, ProblemEach.CanDo3, ProblemEach.CanDo4, ProblemEach.CanDo5]
            .filter(Boolean)
            .map((item, idx) => (
              <li className={styles.canDo__list__item} key={idx}>
                {item}
              </li>
            ))}
        </ul>
      </section>
    </section>
  )
}

export default Problem
